import type { TFunction } from 'i18next';

/**
 * Коды ошибок карьерного домена → польский текст из локали.
 *
 * Зачем это нужно. Сервер пишет сообщения по-русски (они уходят в логи и в
 * Sentry), а интерфейс LMS целиком польский — `REACT_APP_LANG=pl` задаёт и
 * `lng`, и `fallbackLng`. Раньше компоненты делали
 * `result.errorMessage || t('...')`, то есть серверный русский ПЕРЕБИВАЛ уже
 * написанный польский перевод: запасной текст показывался только когда сервер
 * не ответил вовсе.
 *
 * ⚠️ Фолбэк здесь — ТОЛЬКО generic-ключ, никогда не `errorMessage`. В ERP
 * (`erp-tms/src/core/hooks/CareerCenter/careerModel.ts`) последним фолбэком
 * стоит `first?.message`, и русский течёт на экран именно через него —
 * копировать ту форму сюда нельзя.
 *
 * Коды объявлены на бэкенде в `tmsis/career/constants.py`
 * (`ERROR_NOT_A_MEMBER` и соседи) и приезжают в `customErrors[].code`.
 */
export const CareerErrorCode = {
  NOT_A_MEMBER: 'not_a_member',
  NOT_FOUND: 'not_found',
  LESSON_NOT_PUBLISHED: 'lesson_not_published',
  LESSON_LOCKED: 'lesson_locked',
  ARTIFACT_REQUIRED: 'artifact_required',
  INVALID: 'invalid',
  UPLOAD_ERROR: 'upload_error',
} as const;

export const getCareerErrorText = (t: TFunction, code?: string | null): string => {
  switch (code) {
    case CareerErrorCode.NOT_A_MEMBER:
      return t('careerCenter.errors.notAMember');
    case CareerErrorCode.NOT_FOUND:
      return t('careerCenter.errors.notFound');
    case CareerErrorCode.LESSON_NOT_PUBLISHED:
      return t('careerCenter.errors.lessonNotPublished');
    case CareerErrorCode.LESSON_LOCKED:
      return t('careerCenter.errors.lessonLocked');
    case CareerErrorCode.ARTIFACT_REQUIRED:
      return t('careerCenter.errors.artifactRequired');
    case CareerErrorCode.INVALID:
      return t('careerCenter.errors.invalid');
    case CareerErrorCode.UPLOAD_ERROR:
      return t('careerCenter.errors.upload');
    default:
      return t('careerCenter.errors.generic');
  }
};
